import { getEkardoApolloClient, NETFRONT_PRODUCT_QUICKCODES } from '@netfront/common-library';
import {
  ISearchDirectoriesQueryGraphQLResponse,
  ISearchDirectoriesQueryVariables,
  SEARCH_DIRECTORIES_QUERY,
} from '@netfront/ekardo-content-library';
import { NextPage } from 'next';

import { FAQPage, FAQPageProps } from '../components/Pages/FAQPage';
import { FAQ_DIRECTORY_PRODUCTION_ID } from '../components/Pages/FAQPage/FAQPage.constants';
import { STATIC_PAGE_REGENERATION_TIME_IN_SECONDS } from '../constants';

const FAQNextPage: NextPage<FAQPageProps> = ({ faqDirectories }: FAQPageProps) => {
  return <FAQPage faqDirectories={faqDirectories} />;
};

export async function getStaticProps() {
  const client = getEkardoApolloClient({
    product: NETFRONT_PRODUCT_QUICKCODES,
  });

  const {
    data: {
      directory: { searchDirectories: faqDirectories },
    },
  } = await client.query<ISearchDirectoriesQueryGraphQLResponse, ISearchDirectoriesQueryVariables>({
    query: SEARCH_DIRECTORIES_QUERY,
    variables: {
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      directoryTypeId: FAQ_DIRECTORY_PRODUCTION_ID,
    },
  });

  return {
    props: {
      faqDirectories: [...faqDirectories].reverse(),
    },
    revalidate: STATIC_PAGE_REGENERATION_TIME_IN_SECONDS,
  };
}

// eslint-disable-next-line import/no-default-export
export default FAQNextPage;
